<template>
  <div>
    <exo-form hideClose :root="_self" :clear="false">
      <template v-slot:titleTooltip>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="Evasive Maneuver Mission"
        >
          <tooltipEvasiveManeuverMission />
        </exo-help-dialog>
      </template>
      <exo-input-name :root="_self" />
      <v-divider />
      <v-row>
        <v-col>
          <div class="text-h5 mb-4" v-bind:class="[sectionTitleClass]">
            Space Objects
          </div>
          <v-row
            ><v-col
              ><exo-input-ref-notparametric
                :root="_self"
                name="spaceObjectChaser"
                type="spaceObject"
                componentRoute="/spaceobject" /></v-col
            ><v-col
              ><exo-input-ref-notparametric
                :root="_self"
                name="spaceObjectTarget"
                type="spaceObject"
                componentRoute="/spaceobject" /></v-col
          ></v-row>
          <v-divider />
          <v-row>
            <v-col>
              <div class="text-h5 mb-4" v-bind:class="[sectionTitleClass]">
                Initial Orbits
              </div>
            </v-col>
          </v-row>
          <v-row style="border-bottom: 10px"
            ><v-col>
              <exo-input-select
                :root="_self"
                name="orbitChaserDefinitionType" />
              <div v-show="inputs.orbitChaserDefinitionType == 'TLE'">
                Chaser TLE
                <TLEDecoder
                  :tle.sync="inputs.tleChaser"
                  v-on:updateDate="tleChaserDate = $event"
                  :isExpanded="false"
                  :expandDisabled="false"
                ></TLEDecoder>
              </div>
              <div v-show="inputs.orbitChaserDefinitionType == 'ORBIT'">
                <exo-input-ref-notparametric
                  :root="_self"
                  name="orbitChaser"
                  type="orbit"
                  componentRoute="/numericalorbit"
                /></div
            ></v-col>
            <v-col>
              <exo-input-select
                :root="_self"
                name="orbitTargetDefinitionType" />
              <div v-show="inputs.orbitTargetDefinitionType == 'TLE'">
                Target TLE
                <TLEDecoder
                  :tle.sync="inputs.tleTarget"
                  v-on:updateDate="tleTargetDate = $event"
                  :isExpanded="false"
                  :expandDisabled="false"
                ></TLEDecoder>
              </div>
              <div v-show="inputs.orbitTargetDefinitionType == 'ORBIT'">
                <exo-input-ref-notparametric
                  :root="_self"
                  name="orbitTarget"
                  type="orbit"
                  componentRoute="/numericalorbit"
                /></div></v-col
          ></v-row>
          <v-divider style="margin-top: 20px; margin-bottom: 20px"></v-divider>

          <div class="text-h5 mb-4" v-bind:class="[sectionTitleClass]">
            <v-row>
              <v-col cols="6">
                <div
                  class="text-h5 mb-4 ml-5"
                  v-bind:class="[sectionTitleClass]"
                >
                  <v-row>
                    Scenario
                    <exo-help-dialog
                      :margin="'ma-0'"
                      title="Evasive Maneuver Design Scenario"
                    >
                      <tooltipEvasiveScenario />
                    </exo-help-dialog>
                  </v-row>
                </div>
                <v-row>
                  <v-col cols="6">
                    <exo-input-select :root="_self" name="evasiveType" />
                  </v-col>
                  <v-col cols="6">
                    <exo-input-date-time
                      :root="_self"
                      name="referenceDate"
                      :datePickerProps="datePickerPropsReferenceDate"
                  /></v-col>
                </v-row>
              </v-col>

              <v-col cols="6">
                <v-row>
                  <div
                    class="text-h5 mb-4 ml-5"
                    v-bind:class="[sectionTitleClass]"
                  >
                    Constraints
                  </div>
                  <exo-help-dialog
                    :margin="'ma-0'"
                    title="Evasive Maneuver Design Constraints"
                  >
                    <tooltipEvasiveConstraints />
                  </exo-help-dialog>
                </v-row>
                <v-row>
                  <v-col
                    ><v-btn
                      small
                      color="primary"
                      @click="isTimespanDialogOpen = true"
                      >Timespan constraints
                    </v-btn>
                    <v-dialog
                      scrollable
                      width="700"
                      v-model="isTimespanDialogOpen"
                    >
                      <TimespanEvasiveConstraints
                        :timespans.sync="inputs.restrictedDates"
                        :isOpenDialog.sync="isTimespanDialogOpen"
                        :datePickerProps="datePickerPropsTimespanConstraints"
                      /> </v-dialog
                  ></v-col>
                  <v-col>
                    <exo-input-double
                      :root="_self"
                      name="minimumTargetReactionDuration"
                    />
                  </v-col>
                  <v-col
                    ><exo-input-double
                      :root="_self"
                      name="maximumDeltaV" /></v-col
                  ><v-col
                    ><exo-input-double
                      :root="_self"
                      name="minimumApproachDistance"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <v-row
            ><v-col cols="6">
              <v-divider />
              <v-row>
                <v-col>
                  <div class="text-h5 mb-4" v-bind:class="[sectionTitleClass]">
                    <span class="text-truncate">Additional features </span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <exo-input-checkbox
                    :root="_self"
                    name="computeServiceRecovery"
                  />
                </v-col>
                <v-col cols="4">
                  <exo-input-double
                    v-if="inputs.computeServiceRecovery"
                    :root="_self"
                    name="maximumServiceLossDuration"
                  /> </v-col
              ></v-row>
              <v-row>
                <v-col cols="4">
                  <exo-input-checkbox
                    :root="_self"
                    name="computeChaserReaction"
                  />
                </v-col>
                <v-col cols="4">
                  <exo-input-double
                    v-if="inputs.computeChaserReaction"
                    :root="_self"
                    name="minimumChaserReactionDuration"
                  />
                </v-col>
                <v-col cols="4">
                  <exo-input-double
                    v-if="inputs.computeChaserReaction"
                    :root="_self"
                    name="maximumChaserDeltaV"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <exo-input-double
                    :root="_self"
                    name="maximumComputationTime"
                  /> </v-col
                ><v-col cols="1"
                  ><exo-help-dialog
                    margin="mt-6"
                    title="Maximum computation time"
                  >
                    The maximum computation time is used as a stopping condition
                    in the genetic algorithm. Allowing more computation time
                    will therefore lead to more optimized scenarios.
                  </exo-help-dialog></v-col
                ></v-row
              >
            </v-col></v-row
          >

          <template v-if="isDisplayedPlot">
            <v-divider />

            <v-row>
              <v-col>
                <div
                  class="text-h5 mb-8 mt-2"
                  v-bind:class="[sectionTitleClass]"
                >
                  Relative distance between the two spacecrafts
                </div>
                <div class="text-h6 mb-8 mt-2" v-if="displayClosestApproach">
                  <v-row>
                    <v-col cols="6">
                      <span>
                        <b>Closest approach date:</b>
                        {{ closestApproachDate }}</span
                      >
                    </v-col> </v-row
                  ><v-row>
                    <v-col cols="6">
                      <span>
                        <b>Closest approach distance:</b>
                        {{ closestApproachToDisplay }}</span
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row style="width: 100%; justify-content: center">
              <FullscreenGraphComponent
                :traces="relativeDistancePlotTraces"
                :layout="relativeDistancePlotLayout"
                title="Relative distance between the two spacecrafts"
                style="width: 100%; height: 400px"
                :maneuversDates="[
                  ...forbiddenTimespans,
                  ...targetReactionTimespans
                ]"
            /></v-row>
          </template>
          <exo-form-alert v-if="tleDistanceWarning" type="warning" class="mt-3">
            {{ tleDistanceWarning }}
          </exo-form-alert>
        </v-col>
      </v-row>
      <v-row v-if="!timespansValid" class="error--text"
        >Invalid timespan constraints</v-row
      >
    </exo-form>
    <v-col ref="NumericalMissionErrorDisplay"> </v-col>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import plotLayout from '../../mixins/plotLayout.js'
import dataTools from '../../tools/data.js'
import missionTools from '../../store/mission.js'
import { mapGetters } from 'vuex'
import tooltipEvasiveManeuverMission from '../../components/Tooltips/Defense/tooltipEvasiveManeuverMission'
import tooltipEvasiveConstraints from '../../components/Tooltips/Defense/tooltipEvasiveConstraints'
import tooltipEvasiveScenario from '../../components/Tooltips/Defense/tooltipEvasiveScenario'
import fieldsDescription from '../../tools/fieldsDescription.json'
import TLEDecoder from '../../components/Toolbox/TLEDecoder'
import TimespanEvasiveConstraints from './TimespanEvasiveConstraints'
import moment from 'moment'
import FullscreenGraphComponent from './FullscreenGraphComponent'
import asterx from './asterx.mixin.js'

export default {
  name: 'EvasiveManeuverRequest',

  mixins: [formMixin, numericalMixin, plotLayout, asterx],
  components: {
    tooltipEvasiveManeuverMission,
    tooltipEvasiveConstraints,
    tooltipEvasiveScenario,
    TLEDecoder,
    TimespanEvasiveConstraints,
    FullscreenGraphComponent
  },
  computed: {
    ...mapGetters(['missions', 'currentMission', 'currentUser']),

    displayClosestApproach() {
      return this.closestApproach != null && this.closestApproachDate != null
    },

    closestApproachToDisplay() {
      if (this.closestApproach != null) {
        return (
          dataTools.convertSi2Display('distance', this.closestApproach) +
          ' ' +
          dataTools.getDefaultGuiUnit('distance')
        )
      }
    },
    timespansValid() {
      return (
        this.inputs.restrictedDates.findIndex(
          (timespan) =>
            !Array.isArray(timespan) ||
            timespan.length !== 2 ||
            !moment.utc(timespan[0]).isBefore(moment.utc(timespan[1]))
        ) === -1
      )
    },

    inputsValid() {
      let fieldsState = this.verifyPropertiesList(
        this.getRequiredPropertiesList(this.inputs),
        this.inputs,
        true
      )
      fieldsState =
        fieldsState &&
        this.verifyPropertiesList(
          this.getOptionalPropertiesList(this.inputs),
          this.inputs,
          false
        )
      // if impossible to validate a form : uncomment the code in verifyPropertiesList to understand the problematic field
      return this.inputNameState && fieldsState && this.timespansValid
    },

    tleDistanceWarning() {
      if (this.tleTargetDate == null && this.tleChaserDate == null) {
        return null
      }
      const THRESHOLD = 7
      const tleDatesDistance = moment
        .utc(this.tleChaserDate)
        .diff(moment.utc(this.tleTargetDate), 'd')
      if (tleDatesDistance > THRESHOLD) {
        return `The provided TLEs are separated by ${tleDatesDistance} days. Results may be inacurate, especially if a maneuver has occured since the date of the first TLE.`
      }
    },
    relativeDistancePlotLayout() {
      return {
        plot_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        paper_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        font: { color: this.$vuetify.theme.dark ? 'white' : '#121212' },
        xaxis: {
          title: { text: 'Time (Days)' }
        },
        yaxis: {
          title: { text: 'Distance between the space objects (km)' },
          tickformat: '.3g'
        },
        margin: { t: 20 },
        legend: {
          x: 1,
          xanchor: 'right',
          y: 1,
          orientation: 'h'
        }
      }
    },
    sectionTitleClass() {
      if (this.$vuetify.theme.dark) {
        return 'white--text'
      } else {
        return 'black--text'
      }
    },
    isDisplayedPlot() {
      return this.backendErrorMessage == null && this.validOrbitsOrTLEs
    },
    validOrbitsOrTLEs() {
      let valid = true
      if (this.inputs.orbitChaserDefinitionType === 'TLE') {
        valid =
          valid &&
          this.validTLE(this.inputs.tleChaser) &&
          this.validTLEDate(this.tleChaserDate)
      } else {
        valid = valid && this.validOrbit(this.inputs.orbitChaser)
      }
      if (this.inputs.orbitTargetDefinitionType === 'TLE') {
        valid =
          valid &&
          this.validTLE(this.inputs.tleTarget) &&
          this.validTLEDate(this.tleTargetDate)
      } else {
        valid = valid && this.validOrbit(this.inputs.orbitTarget)
      }

      return valid
    },
    forbiddenTimespans() {
      const validDates = this.inputs.restrictedDates.filter(
        (dates) => dates?.length === 2 && dates[0] && dates[1]
      )
      return [
        {
          legendText: 'No target maneuvers allowed',
          color: 'grey',
          dates: validDates
        }
      ]
    },
    targetReactionTimespans() {
      if (
        !this.inputs.minimumTargetReactionDuration ||
        !this.initialPropagationDate
      ) {
        return []
      }
      const lastDate = moment(this.initialPropagationDate).add(
        this.inputs.minimumTargetReactionDuration,
        'h'
      )
      return [
        {
          legendText: 'Target minimum reaction duration',
          color: 'blue',
          dates: [[this.initialPropagationDate, lastDate.toISOString()]]
        }
      ]
    },

    lastOrbitalDate() {
      let chaserDate, targetDate
      if (this.inputs.orbitTargetDefinitionType === 'TLE') {
        targetDate = this.tleTargetDate
      } else {
        targetDate = this.inputs.orbitTarget?.orbitDateTime
      }
      if (this.inputs.orbitChaserDefinitionType === 'TLE') {
        chaserDate = this.tleChaserDate
      } else {
        chaserDate = this.inputs.orbitChaser?.orbitDateTime
      }

      if (targetDate && chaserDate) {
        return moment
          .max(moment.utc(targetDate), moment.utc(chaserDate))
          .toISOString()
      } else {
        return null
      }
    },

    initialPropagationDate() {
      return this.inputs.referenceDate || this.lastOrbitalDate
    },

    datePickerPropsReferenceDate() {
      return this.lastOrbitalDate
        ? { 'show-current': this.lastOrbitalDate.substring(0, 10) }
        : {}
    },
    datePickerPropsTimespanConstraints() {
      return this.initialPropagationDate
        ? { 'show-current': this.initialPropagationDate.substring(0, 10) }
        : {}
    }
  },

  watch: {
    'inputs.tleChaser'() {
      this.tryUpdatePlot()
    },
    'inputs.tleTarget'() {
      this.tryUpdatePlot()
    },
    'inputs.orbitTarget'() {
      this.tryUpdatePlot()
    },
    'inputs.orbitChaser'() {
      this.tryUpdatePlot()
    },
    'inputs.referenceDate'() {
      this.tryUpdatePlot()
    },
    'inputs.orbitChaserDefinitionType'() {
      this.tryUpdatePlot()
    },
    'inputs.orbitTargetDefinitionType'() {
      this.tryUpdatePlot()
    },
    'inputs.evasiveType'(newValue) {
      if (newValue === 'RPO_ESCAPE') {
        this.inputs.computeServiceRecovery = false
      }
    }
  },

  async mounted() {
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    this.$root.$on('copy-mission', this.copyMission)
    this.$root.$on('create-mission', this.createMission)
    this.refreshSpaceObjects()
    this.refreshNumericalOrbits()
    this.refreshForm()
  },

  beforeDestroy() {
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
    this.$root.$off('copy-mission', this.copyMission)
    this.$root.$off('create-mission', this.createMission)
  },

  data() {
    return {
      enumPropertiesList: this.getEnumProperties(),

      missionPlot: null,

      modalRef: { content: [] },
      showModal: false,
      maneuveringStrategies: {},

      inputs: {
        editing: true,
        type: this.getDefaultValue('type'),
        layout: this.getDefaultValue('layout'), // to save the dashboard, should be optional in fieldsdescription to be automatically copied
        spaceObjectChaser: this.getDefaultValue('spaceObjectChaser'),
        spaceObjectTarget: this.getDefaultValue('spaceObjectTarget'),
        tleChaser: null,
        tleTarget: null,
        computeServiceRecovery: this.getDefaultValue('computeServiceRecovery'),
        computeChaserReaction: this.getDefaultValue('computeChaserReaction'),
        orbitChaser: this.getDefaultValue('orbitChaser'),
        orbitTarget: this.getDefaultValue('orbitTarget'),
        maximumComputationTime: this.getDefaultValue('maximumComputationTime'),
        maximumDeltaV: this.getDefaultValue('maximumDeltaV'),
        maximumChaserDeltaV: this.getDefaultValue('maximumChaserDeltaV'),
        minimumApproachDistance: this.getDefaultValue(
          'minimumApproachDistance'
        ),
        maximumServiceLossDuration: this.getDefaultValue(
          'maximumServiceLossDuration'
        ),
        minimumTargetReactionDuration: this.getDefaultValue(
          'minimumTargetReactionDuration'
        ),
        minimumChaserReactionDuration: this.getDefaultValue(
          'minimumChaserReactionDuration'
        ),
        referenceDate: this.getDefaultValue('referenceDate'),
        restrictedDates: this.getDefaultValue('restrictedDates'),
        orbitChaserDefinitionType: this.getDefaultValue(
          'orbitChaserDefinitionType'
        ),
        orbitTargetDefinitionType: this.getDefaultValue(
          'orbitTargetDefinitionType'
        ),
        evasiveType: this.getDefaultValue('evasiveType')
      },
      spaceObjectsNotParametrics: [],
      orbitsNotParametrics: [],

      modalInfo: { title: '', content: '', config: {} },
      modalError: { title: '', content: '' },
      displayed: null,
      enableFormCache: false,
      tleChaserDate: null,
      tleTargetDate: null,
      closestApproach: null,
      closestApproachDate: null,
      backendErrorMessage: null,
      isTimespanDialogOpen: false,
      relativeDistancePlotTraces: null
    }
  },

  methods: {
    refreshTable() {},

    refreshSpaceObjects() {
      let self = this
      this.$http
        .get(this.getAPI('spaceobjectdefinitions'))
        .then((response) => {
          self.spaceObjectsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of space objects. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    refreshNumericalOrbits() {
      let self = this
      this.$http
        .get(this.getAPI('orbitdefinitions'))
        .then((response) => {
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of numerical orbits. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    validOrbit(orbit) {
      return orbit != null
    },
    validTLE(tle) {
      return tle != null && tle.length > 1
    },
    validTLEDate(tleDate) {
      return tleDate != null
    },

    computeClosestApproach(relativeDistances, propagationDates) {
      this.closestApproach = Math.min(...relativeDistances)
      for (let index = 0; index < propagationDates.length; index++) {
        if (relativeDistances[index] === this.closestApproach) {
          this.closestApproachDate = propagationDates[index]
          break
        }
      }
    },

    getCurrentFormTitle() {
      return this.inputs.type + ' Mission'
    },

    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.inputs.type = mission.type
        this.inputs.editing = false
        this.sendFormToServer()
      }
    },

    currentMissionUpdatedHandler() {
      this.refreshForm()
    },

    getSubTypes(instance) {
      let types = {
        orbitChaserDefinitionType: instance.orbitChaserDefinitionType,
        orbitTargetDefinitionType: instance.orbitTargetDefinitionType,
        evasiveType: instance.evasiveType
      }
      return types
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        if (this.currentMission.id !== this.inputs.id) {
          // different mission reload completely the form
          this.edit(this.currentMission, 0)
        } else {
          // reloading the current mission
          // only refresh the updated fields
          const fieldsToUpdate = [
            this.orbitsNotParametrics,
            this.spaceObjectsNotParametrics
          ]
          missionTools.updateAllReferences(this, fieldsToUpdate)
          this.inputs.layout = this.currentMission.layout // might be saved from dashboard
        }
      }
    },

    updateAllReferences() {
      this.inputs.editing = true
      this.checkReferences(this.currentMission, this.inputs)
    },

    checkReferences(missionSource, missionToUpdate) {
      if (missionSource != null && missionToUpdate != null) {
        for (let field in this.getPropertiesDescription()) {
          if (missionSource[field] != null && missionToUpdate[field] != null) {
            if (
              missionSource[field].id != null &&
              missionSource[field].id === missionToUpdate[field].id
            ) {
              missionToUpdate[field] = missionSource[field]
            }
          }
        }
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    // redefine from form.js to keep the form open on the upadted data
    async onSave() {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.flushLocallySavedParametersForMission()
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    async onCreate() {
      let self = this
      let objectName = this.inputs.name.trim()
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.flushLocallySavedParametersForMission()
          self.inputs.saving = false
          self.clearForm()
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          self.inputs.saving = false
          self.displayMessage(
            'Error creating ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          throw e
        })
    },
    getResultFieldType(field) {
      return dataTools.getFieldTypeFromPath(
        ['maneuverReport', field],
        'SimulationResult',
        null
      )
    },

    getResultDefaultUnitLabel(field) {
      let fieldType = this.getResultFieldType(field)
      return (
        ' ' + dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    tryUpdatePlot() {
      this.backendErrorMessage = null
      if (this.isDisplayedPlot) {
        this.updatePlot()
      }
    },

    async updatePlot() {
      const request = {
        firstOrbitDefinitionType: this.inputs.orbitChaserDefinitionType,
        secondOrbitDefinitionType: this.inputs.orbitTargetDefinitionType,
        firstOrbit: this.inputs.orbitChaser,
        secondOrbit: this.inputs.orbitTarget,
        firstTLE: this.inputs.tleChaser,
        secondTLE: this.inputs.tleTarget,
        initialPropagationDate: this.initialPropagationDate,
        finalPropagationDate: moment
          .utc(this.initialPropagationDate)
          .add(7, 'd'),
        propagatorType: 'KEPLERIAN'
      }
      const { data, error } = await this.$http
        .post('/physics/relativedistance', request)
        .then(function (response) {
          return { data: response.data, error: null }
        })
        .catch((e) => {
          if (
            e.response &&
            e.response.status === 400 &&
            e.response.data.startsWith('Invalid definition')
          ) {
            return {
              data: null,
              error: e.response.data.match(
                /Invalid definition\. (?<message>.*)/
              )?.groups?.message
            }
          } else {
            return {
              data: null,
              error:
                'An error occured while trying to communicate with the server'
            }
          }
        })

      this.backendErrorMessage = error
      if (this.backendErrorMessage == null) {
        this.computeClosestApproach(
          data.relativeDistanceEphemerides,
          data.propagationDates
        )

        this.relativeDistancePlotTraces = [
          {
            x: data.propagationDates,
            y: data.relativeDistanceEphemerides.map((x) => x / 1000),
            marker: {
              color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
            },
            showlegend: false,
            hovertemplate: '%{y}<extra></extra>'
          }
        ]
      } else {
        this.relativeDistancePlotTraces = null
        this.displayMessage(
          'Relative distances plot unavailable',
          this.backendErrorMessage,
          'notification',
          'warning'
        )
      }
    },

    // methods to mange form & table like other components

    getCurrentFormType() {
      return 'EvasiveManeuverRequest'
    }
  }
}
</script>
